import axios from 'axios';

const baseUrl = String((window as any).baseUrl || '').replace(/\/+$/, '').replace(/\/rest$/i, '');

export default axios.create({ baseURL: `${baseUrl}/api/JC261/` });
